const style = {
    margin: '1rem 0 .5rem 0',
    textAlign: 'center',
    margin: '1rem 0 .5rem 0',
    display: 'flex',
    fontSize: '1.3em',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center'
}

const Heading = (props) => <h1 style={style}>{props.name}</h1>

export default Heading

Heading.defaultProps = {
    name: 'عنوان',
    lead: ''
}